<template>
  <header class="bg-white w-full z-30 fixed top-0 border-b border-gray-lighter">
      <slot>
          <div class="container mx-auto px-4 py-4 flex justify-between items-center">
              <a href="/" class="logo block w-1/2 md:w-3/12  xl:w-3/12 flex items-center">
                  <img src="/images/pflegeplanet_logo.png" class="logo-image- w-full h-auto" style="max-width: 260px;"/>
              </a>
              <div class="flex flex-col md:flex-row w-6/12 md:w-8/12 items-end md:items-center justify-end text-sm md:text-base text-right md:text-center whitespace-nowrap">
                  <span class="text-gray md:text-gray-light inline-block">Kostenlose Beratung:</span> <a class="text-primary flex items-center ml-2" href="tel:08009886053"><Icon name="phone" class="inline-block mr-1 md:mr-2 h-6 w-6 md:h-10 md:w-10"/>0800 988 60 53</a><span class="hidden lg:inline-block w-0 border-r border-block pl-6 mr-6 h-8 border-header"></span><span class="hidden lg:inline-block text-secondary">Mo – Do <span class="font-medium inline-block mr-2">09 – 18 Uhr </span>  Fr <span class="font-medium">9 – 16 Uhr</span></span>
              </div>
              <a :href="wordpressUrl" class="text-primary whitespace-nowrap- block h-full hover:text-secondary font-medium text-sm ml-4 sm:text-lg hidden xl:block w-1/3 md:w-1/12 xl:w-3/12 text-right">
                Zurück zur Startseite
              </a>
        </div>
      </slot>
  </header>
</template>

<script>

import {getCurrentInstance} from "vue";

export default {
    name: "PageHeader",
    setup() {
        const app = getCurrentInstance();
        const wordpressUrl = window.CMS_URL;

        return {
            wordpressUrl
        }
    }
}
</script>

<style scoped>

</style>
